enum Role {
  Viewer = "viewer",
  Normal = "normal",
  Owner = "owner",
}

export enum LiveChatRole {
  Normal = "livechat_normal",
  Admin = "livechat_admin",
  Owner = "livechat_owner",
  ViceOwner = "livechat_viceowner",
}

export const readableRoles = {
  [Role.Owner]: {
    name: "Admin",
    description:
      "Has full access to global settings and the option to invite new agents, make changes to subscriptions and use all ticketing features.",
  },
  [Role.Normal]: {
    name: "Agent",
    description: "Has access to personal settings and can use all ticketing features.",
  },
  [Role.Viewer]: {
    name: "Viewer",
    description: "Can browse and read tickets for free without modifying them.",
  },
};

export default Role;
